module.exports = __webpack_public_path__ + "img/mobile-banner.57b1470e.png";